/* eslint-disable import/prefer-default-export */
import Request from 'libs/requests';
import { User } from 'stores/user/userTypes';

export async function getUsers() {
  const response = await Request.get('/api/admin/');
  return response.data;
}

export async function patchUser(user: User) {
  const response = await Request.patch(
    `/api/admin/${user.id}/`,
    {
      activated: user.activated,
      is_staff: user.is_staff,
    },
  );
  return response.data;
}

export async function patchUserNote(userWPId: string, note: string) {
  const response = await Request.patch(
    `/api/doctors/${userWPId}/note/`,
    { note },
  );
  return response.data;
}

const getUserRatesControllers: Record<string, AbortController> = {};

export async function getUserRates(userWPId: string, params: URLSearchParams) {
  if (getUserRatesControllers[userWPId]) {
    getUserRatesControllers[userWPId].abort();
  }

  getUserRatesControllers[userWPId] = new AbortController();

  const response = await Request.get(
    `/api/admin/${userWPId}/rate/`,
    {
      signal: getUserRatesControllers[userWPId].signal,
      params,
    },
  );

  return response.data;
}
